/**
 * Legacy tab ids that must not remain in columnConfig.visibleTabs.
 * Sprint 5.2a retired the dead project_artifacts shell tab.
 * DEC-10: Risks is hidden from nav until the org/project risk surface is remounted.
 * TC-F2b: `documents` is first-class again (document_instances store) — do not strip it.
 */
import {
  normalizeColumnConfig,
  toFlatColumnConfig,
  withVisibleTabs,
  type ColumnConfig,
} from '@/features/templates/columnConfig.model';

const LEGACY_TAB_IDS = new Set(['project_artifacts', 'risks']);

/** Remove deprecated tab ids from columnConfig.visibleTabs (preserves columns + defaultView). */
export function stripLegacyVisibleTabs(
  columnConfig?: ColumnConfig | Record<string, unknown> | null,
): ColumnConfig {
  const nested = normalizeColumnConfig(columnConfig ?? {});
  const raw = nested.visibleTabs;
  if (!Array.isArray(raw)) return nested;
  const filtered = raw.filter(
    (id): id is string => typeof id === 'string' && !LEGACY_TAB_IDS.has(id),
  );
  return withVisibleTabs(nested, filtered);
}

/** Wire form for APIs that still expect flat JSONB. */
export function stripLegacyVisibleTabsFlat(
  columnConfig?: ColumnConfig | Record<string, unknown> | null,
): Record<string, boolean | string | string[]> {
  return toFlatColumnConfig(stripLegacyVisibleTabs(columnConfig));
}

export function columnConfigHasLegacyTabs(
  columnConfig?: ColumnConfig | Record<string, unknown> | null,
): boolean {
  const raw = normalizeColumnConfig(columnConfig ?? {}).visibleTabs;
  if (!Array.isArray(raw)) return false;
  return raw.some((id) => typeof id === 'string' && LEGACY_TAB_IDS.has(id));
}
